import React, { useState, useEffect, useMemo } from 'react';
import { Row, Col } from 'reactstrap';
import { useTranslation } from "react-i18next";
import DataTable from 'react-data-table-component';
import axios from 'axios';
import bag from "../../Assets/Images/finance/bag.jpg";
import svgTry from "../../Assets/Images/finance/currency/try.svg";
import svgUsd from "../../Assets/Images/finance/currency/usd.svg";
import svgEur from "../../Assets/Images/finance/currency/eur.svg";
import svgGbp from "../../Assets/Images/finance/currency/gbp.svg";
import svgDefault from "../../Assets/Images/finance/currency/try.svg";
import { ToastContainer, toast } from 'react-toastify';
import { useParams } from "react-router-dom";
import CompLoaderDt from '../Common/CompLoaderDt';


function CompDtCashDesk() {
    const { t } = useTranslation();
    const params = useParams();
    let crmId = params.crmId;

    const [componentId] = useState('compDtCashDesk');
    const [data, setData] = useState(null);

    const [pageNumber, setPageNumber] = useState(0);
    const [pageSize, setPageSize] = useState(5);
    const [sort, setSort] = useState('createDate,DESC');
    const [paginationRowsPerPageOptions] = useState([1, 5, 10, 25, 50, 100]);
    const [totalRows, setTotalRows] = useState(0);

    React.useMemo(() => {
        if (sessionStorage.getItem("currentSession") !== null && sessionStorage.getItem("currentSession")?.bearerToken !== '') {
            if (crmId && crmId) {
                let currentSession = sessionStorage.getItem("currentSession");
                axios.defaults.headers.common["X-User-Language"] = t('language')?.toUpperCase();
                axios.defaults.headers.common["Authorization"] = currentSession !== null ? JSON.parse(currentSession)?.bearerToken : null;
                let ApiGateway = process.env.REACT_APP_API_URL;
                axios.get(ApiGateway + '/finance/account/cash-desk/crm/' + crmId + '/find-and-list?pageNumber=' + pageNumber + '&pageSize=' + pageSize + '&sort=' + sort)
                    .then(response => {
                        if (response.data?.isSucceed === true) {
                            setData(response.data?.payload);
                        }

                    })
                    .catch(error => {
                        console.error(error);
                    });
            }
        }
    }, [t, crmId, pageNumber, pageSize, sort]);

    const [deleteModal, setDeleteModal] = useState(false);
    const [recordId, setRecordId] = useState(false);

    const onGoToItemDetails = props => {
        //history.push('/product/' + props);
        //dispatch(mpMyCashDeskListApi(props));
    };

    const onBtnDeleteItem = props => {
        let message = 'Prohibited action!';
        toast.error(message, { autoClose: 1000 });
        console.log(props);
        setRecordId(props);
        //setDeleteModal(true);
    };

    const handleDeleteTask = () => {
        if (recordId) {
            //dispatch(mpMyCashDeskDeleteByIdApi({ cashDeskId: recordId }));
            //setDeleteModal(false);
            //dispatch(mpMyCashDeskListApi(pageNumber, pageSize, sort));
            //dispatch(mpMyCashDeskListApi(pageNumber, pageSize, sort));
        }
    };


    useEffect(() => {
        //dispatch(mpMyCashDeskListApi(pageNumber, pageSize, sort));
    }, []);


    const handlePageChange = page => {
        setPageNumber(page - 1);
        //dispatch(mpMyCashDeskListApi(page - 1, pageSize, sort));
    }

    const handlePerRowsChange = async (newPerPage, page) => {
        setPageSize(newPerPage);
        //dispatch(mpMyCashDeskListApi(0, newPerPage, sort));
    }

    const columns = [
        {
            name: <span className='font-weight-bold fs-13'>{t('components.crm.comp-dt-cash-desk.dt.th.cash-desk-name')}</span>,
            selector: row =>
                <div className="d-flex align-items-center mt-2">
                    <div className="flex-shrink-0 mb-2">
                        <img src={bag} width={28} height={28} alt="" className="avatar-xs rounded-circle" />
                    </div>
                    <div className="flex-grow-1 ms-2">
                        <h6 className="mb-1"><span title={row?.name}>{row?.name}</span></h6>
                        <p className="text-muted mb-2"><span title={row?.bankAccount?.bankBranch?.name}>{row?.bankAccount?.bankBranch?.name}</span></p>
                    </div>
                    <div className="flex-shrink-0">
                    </div>
                </div>
            ,
            sortable: false,
            maxWidth: "225px"
        },
        {
            name: <span className='font-weight-bold fs-13'>{t('components.crm.comp-dt-cash-desk.dt.th.currency')}</span>,
            selector: row => {
                switch (row.account?.currency?.shortCode) {
                    case "TRY":
                        return <span><img src={svgTry} width={21} height={21} alt="" className="avatar-xxs me-2" /> <span title={row?.account?.currency?.name} className=''>{row?.account?.currency?.name}</span></span>;
                    case "USD":
                        return <span><img src={svgUsd} width={21} height={21} alt="" className="avatar-xxs me-2" /> <span title={row?.account?.currency?.name} className=''>{row?.account?.currency?.name}</span></span>;
                    case "EUR":
                        return <span><img src={svgEur} width={21} height={21} alt="" className="avatar-xxs me-2" /> <span title={row?.account?.currency?.name} className=''>{row?.account?.currency?.name}</span></span>;
                    case "GBP":
                        return <span><img src={svgGbp} width={21} height={21} alt="" className="avatar-xxs me-2" /> <span title={row?.account?.currency?.name} className=''>{row?.account?.currency?.name}</span></span>;
                    default:
                        return <span><img src={svgDefault} width={21} height={21} alt="" className="avatar-xxs me-2" /> <span title={row?.account?.currency?.name} className=''>{row?.account?.currency?.name}</span></span>;
                }
            },
            sortable: false,
            maxWidth: "125px"
        },
        {
            name: <span className='font-weight-bold fs-13'>{t('components.crm.comp-dt-cash-desk.dt.th.iban')}</span>,
            selector: row => <span title={row?.bankAccount?.bankAccountiban}>{row?.bankAccount?.bankAccountiban}</span>,
            sortable: false,
            maxWidth: "225px"
        },
        {
            name: <span className='font-weight-bold fs-13'>{t('components.crm.comp-dt-cash-desk.dt.th.account-holder')}</span>,
            selector: row => <span title={row?.bankAccount?.bankAccountName}>{row?.bankAccount?.bankAccountName}</span>,
            sortable: false,
            maxWidth: "280px"
        },
    ];

    const [pending, setPending] = useState(true);
    const [rows, setRows] = useState([]);
    useEffect(() => {
        const timeout = setTimeout(() => {
            setRows(data?.content);
            setPending(false);
            setTotalRows(data?.page?.totalElements);
        }, 0);
        return () => clearTimeout(timeout);
    }, [data]);

    return (
        <React.Fragment>
            <ToastContainer />
            {data ? ((
                <DataTable
                    id={componentId}
                    columns={columns}
                    data={rows}
                    pagination={true}
                    paginationServer
                    onPageChange={page => setPageNumber(page)}
                    paginationPerPage={pageSize}
                    paginationTotalRows={totalRows}
                    onChangePage={handlePageChange}
                    onChangeRowsPerPage={handlePerRowsChange}
                    progressPending={pending}
                    noDataComponent={t('data-table.label.no-data')}
                    paginationRowsPerPageOptions={paginationRowsPerPageOptions}
                    paginationComponentOptions={{
                        rowsPerPageText: t('data-table.label.rows-per-page'),
                        rangeSeparatorText: t('data-table.label.out-of'),
                    }}
                />
            )) : (
                <Row>
                    <Col className={"col-md-12 text-center"}>
                        <CompLoaderDt />
                    </Col>
                </Row>
            )}
        </React.Fragment>
    );
}
export default CompDtCashDesk;